Array.prototype._not = function (selectors) {
  return [...this].filter(function (ele) {
    return !ele.matches(selectors);
  });
};